export default "__VITE_ASSET__CiwU6vut__"